import { Component, Fragment } from 'react';
import thousands from 'thousands';
import { Grid, Message } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

const getActivityCountLabel = (isManualChart, t) => {
  return isManualChart
    ? t('report.activity_evaluations')
    : t('report.activity_count');
};
const getTotalParticipantsLabel = (isManualChart, t) => {
  return isManualChart
    ? t('report.participants')
    : t('report.total_participants');
};
const getTotalRespondentsLabel = (isManualChart, t) => {
  return isManualChart
    ? t('report.respondents')
    : t('report.total_respondents');
};

export const PostLegends = ({ average = false, t }) => (
  <div className="legend-labels extra-margin">
    {average ? (
      <Fragment>
        <div className="average-box"></div>
        <div className="text-change">{t('report.average')}</div>
      </Fragment>
    ) : null}
    <div className="response-box"></div>
    <div className="text-change">{t('report.response')}</div>
  </div>
);

export const PostPreLegends = ({ t }) => (
  <div className="legend-labels post-pre-legend-custom">
    <div className="before-response"></div>
    <div className="text-change"> {t('report.before_response')}</div>
    <div className="after-response"></div>
    <div className="text-change">{t('report.after_response')}</div>

    <div className="before-box"></div>
    <div className="text-change">{t('report.before_average')}</div>

    <div className="after-box"></div>
    <div className="text-change">{t('report.after_average')}</div>
  </div>
);

export const SelfAssessedPostPreLegends = ({ t }) => (
  <div className="self-assessed-legends-labels extra-margin">
    <div className="before-response"></div>
    <div className="text-change"> {t('report.before_rating')}</div>
    <div className="after-response"></div>
    <div className="text-change">{t('report.after_rating')}</div>
  </div>
);

export const SelfAssessedPostLegends = ({ average = false, t }) => (
  <div className="self-assessed-legends-labels">
    {average ? (
      <Fragment>
        <div className="after-box"></div>
        <div className="text-change">{t('report.average')}</div>
      </Fragment>
    ) : null}
    <div className="after-response"></div>
    <div className="text-change">{t('report.responses')}</div>
  </div>
);

export const SelfAssessedLegend = ({
  da,
  evalPlansCount,
  documentationSelfAssessed,
  grantAct,
  isProgramActivity,
  isManualChart = false,
  t,
}) => (
  <Grid>
    <Grid.Row>
      {isProgramActivity && (
        <Grid.Column mobile={16} tablet={8} computer={4}>
          <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
            {t('report.program_activity_count')} :
            {da.summary.programsActivityCount
              ? ` ${thousands(da.summary.programsActivityCount)}`
              : ` 0`}
          </div>
        </Grid.Column>
      )}
      {!documentationSelfAssessed && (
        <Grid.Column mobile={16} tablet={8} computer={4}>
          <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
            {documentationSelfAssessed
              ? null
              : isProgramActivity
                ? da.summary.linkedActivityCount
                  ? `${t('report.linked_activity_count')} : ${thousands(
                      da.summary.linkedActivityCount
                    )}`
                  : `${t('report.linked_activity_count')} : 0`
                : t('report.activity_count_with_count', {
                    count: da.summary.activityCount
                      ? thousands(da.summary.activityCount)
                      : 0,
                  })}
          </div>
        </Grid.Column>
      )}

      <Grid.Column mobile={16} tablet={8} computer={4}>
        <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
          {t('report.evaluation_plan_count_with_count', {
            count: evalPlansCount,
          })}
        </div>
      </Grid.Column>
      <Grid.Column mobile={16} tablet={8} computer={4}>
        <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
          {grantAct
            ? `${t('report.total_participants')}`
            : `${t('report.total_activity_participants')}`}{' '}
          : {''}
          {da.summary.actualParticipants
            ? thousands(parseInt(da.summary.actualParticipants))
            : 0}
        </div>
      </Grid.Column>

      <Grid.Column mobile={16} tablet={8} computer={4}>
        <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
          {t('report.total_participants_assessed')} :{' '}
          {da.summary.totalResponse ? thousands(da.summary.totalResponse) : 0}
        </div>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export const Legends = ({
  da,
  evalPlan,
  documentation,
  isSeries,
  isProgramActivity,
  isManualChart = false,
  t,
}) => {
  return (
    <Grid>
      <Grid.Row className="report-activity-count">
        {isProgramActivity && (
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div
              className={`diff ${isManualChart && 'manual-chart-font-size'}`}
            >
              {t('report.program_activity_count')} :
              {da.summary.programsActivityCount
                ? ` ${thousands(da.summary.programsActivityCount)}`
                : ` 0`}
            </div>
          </Grid.Column>
        )}

        {evalPlan ? (
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div
              className={`diff ${isManualChart && 'manual-chart-font-size'}`}
            >
              {t('report.evaluation_plan_count_with_count', {
                count: da.summary.evalCount
                  ? thousands(da.summary.evalCount)
                  : 0,
              })}
            </div>
          </Grid.Column>
        ) : (
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div
              className={`diff ${isManualChart && 'manual-chart-font-size'}`}
            >
              {isProgramActivity
                ? da.summary.linkedActivityCount
                  ? `${t('report.linked_activity_count')} : ${thousands(
                      da.summary.linkedActivityCount
                    )}`
                  : `${t('report.linked_activity_count')} : 0`
                : da.summary.activityCount
                  ? `${getActivityCountLabel(isManualChart, t)} : ${thousands(
                      da.summary.activityCount
                    )}`
                  : `${getActivityCountLabel(isManualChart, t)} : 0`}
            </div>
          </Grid.Column>
        )}

        <Grid.Column mobile={16} tablet={8} computer={4}>
          <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
            {documentation
              ? `${t('report.total_activity_participants')} : `
              : `${getTotalParticipantsLabel(isManualChart, t)} : `}
            {da.summary.totalParticipant
              ? thousands(parseInt(da.summary.totalParticipant))
              : 0}
          </div>
        </Grid.Column>

        <Grid.Column mobile={16} tablet={8} computer={4}>
          <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
            {isSeries
              ? `${t('report.total_responses')}`
              : ` ${getTotalRespondentsLabel(isManualChart, t)} : `}
            {da.summary.totalResponse ? thousands(da.summary.totalResponse) : 0}
          </div>
        </Grid.Column>

        {!isSeries && (
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div
              className={`diff ${isManualChart && 'manual-chart-font-size'}`}
            >
              {t('report.respondent_percentage')} :{' '}
              {da.summary.totalParticipant && da.summary.totalResponse
                ? thousands(
                    Math.round(
                      (da.summary.totalResponse / da.summary.totalParticipant) *
                        100
                    )
                  )
                : 0}{' '}
              %
            </div>
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid>
  );
};

export const DocumentationPageIndividualLegends = ({
  da,
  isSeries,
  isManualChart = false,
  t,
}) => (
  <div className="counts">
    <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
      {t('report.participants')} :{' '}
      {da.summary.totalParticipant
        ? thousands(parseInt(da.summary.totalParticipant))
        : 0}
    </div>
    <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
      {t('report.respondents')} :{' '}
      {da.summary.totalResponse ? thousands(da.summary.totalResponse) : 0}
    </div>
    {!isSeries && (
      <div className={`diff ${isManualChart && 'manual-chart-font-size'}`}>
        {t('report.respondent_percentage')} :{' '}
        {da.summary.totalParticipant && da.summary.totalResponse
          ? thousands(
              Math.round(
                (da.summary.totalResponse / da.summary.totalParticipant) * 100
              )
            )
          : 0}{' '}
        %
      </div>
    )}
  </div>
);

export const Intercept = ({ showInterceptLegend = true, t }) =>
  showInterceptLegend ? (
    <div className="legend-labels extra-margin">
      <div className="average-box-intercept"></div>
      <div className="text-change">{t('report.average')}</div>
      <div className="response-box-intercept"></div>
      <div className="text-change">{t('report.response')}</div>
    </div>
  ) : null;

export const CustomNotification = ({ messageBanner }) => (
  <div className="msg-report">
    <Message color="blue" icon="exclamation circle" content={messageBanner} />
  </div>
);

class CustomReportHeader extends Component {
  render() {
    let {
      evalPlan,
      da,
      // legendResponse,
      allLegends,
      evalPlansCount,
      isIntercept,
      isSelfAssessedMethod = false,
      documentation,
      documentationSelfAssessed,
      grantAct,
      showInterceptLegend,
      isDocumentationLegends = false,
      isSeries = false,
      activityType,
      isManualChart = false,
      t,
    } = this.props;

    const programTypes = [
      'grant_program',
      'festival_program',
      'multi_activity_program',
    ];

    const isProgramActivity = programTypes.includes(activityType);

    return (
      <div>
        {/* {isDocumentationLegends ? null : isSelfAssessedMethod ? (
          da.summary.totalResponse >= 2 ? (
            <CustomNotification
              messageBanner={
                'Manager-assessed evaluation is provided by a single person, usually the activity manager. The assessment is distributed by a standard deviation to spread the single rating into the bell curve.'
              }
            />
          ) : null
        ) : isIntercept ? null : (
          <CustomNotification
            messageBanner={
              'Evaluations using manager assessment and intercept methods cannot be aggregated with other methods. To view manager-assessed or intercept results, select from the method field above.'
            }
          />
        )} */}

        <div className="report-new">
          {isDocumentationLegends ? (
            <DocumentationPageIndividualLegends
              da={da}
              isSeries={isSeries}
              isManualChart={isManualChart}
              t={t}
            />
          ) : isSelfAssessedMethod ? (
            <div>
              {isSelfAssessedMethod ? null : isIntercept ? (
                <Intercept
                  showInterceptLegend={showInterceptLegend}
                  isManualChart={isManualChart}
                  t={t}
                />
              ) : (
                <>{allLegends ? <PostPreLegends t={t} /> : null}</>
              )}
              <SelfAssessedLegend
                da={da}
                evalPlansCount={evalPlansCount}
                documentationSelfAssessed={documentationSelfAssessed}
                grantAct={grantAct}
                isSeries={isSeries}
                isProgramActivity={isProgramActivity} // isProgramActivity only come from system report
                isManualChart={isManualChart}
                t={t}
              />
            </div>
          ) : (
            <div>
              {isSelfAssessedMethod || isIntercept ? null : (
                //:  isIntercept ? (
                //   <Intercept showInterceptLegend={showInterceptLegend} />
                // )
                <>{allLegends ? <PostPreLegends t={t} /> : null}</>
              )}
              <Legends
                da={da}
                evalPlan={evalPlan}
                documentation={documentation}
                isSeries={isSeries}
                isProgramActivity={isProgramActivity} // isProgramActivity only come from system report
                isManualChart={isManualChart}
                t={t}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

CustomReportHeader = withTranslation()(CustomReportHeader);
export { CustomReportHeader };
